// Lector/escritor de validacion.json en SharePoint vía Microsoft Graph.
//
// El archivo vive en la raíz del proyecto:
//   Documentación para Consultoria/validacion.json
//
// Esquema documentado en CLAUDE.md sección 11.

import { getGraphClient } from './graph-client.js'
import { getSiteId, PROJECT_ROOT } from './sharepoint-reader.js'

export const VALIDATION_FILENAME = 'validacion.json'
export const VALIDATION_PATH = `${PROJECT_ROOT}/${VALIDATION_FILENAME}`

function encodePathSegments(path) {
  return String(path || '')
    .split('/')
    .map(encodeURIComponent)
    .join('/')
}

/**
 * Devuelve el contenido JSON parseado de validacion.json, o null si no
 * existe aún en SharePoint (HTTP 404).
 */
export async function loadValidationJson() {
  const client = getGraphClient()
  const siteId = await getSiteId()
  const encoded = encodePathSegments(VALIDATION_PATH)
  const endpoint = `/sites/${siteId}/drive/root:/${encoded}:/content`

  try {
    const result = await client.api(endpoint).get()
    // Si el SDK trata el contenido como texto (algunas builds devuelven
    // string), parseamos manualmente.
    if (typeof result === 'string') return JSON.parse(result)
    if (result && typeof result === 'object') return result
    return null
  } catch (err) {
    if (err?.statusCode === 404) return null
    throw err
  }
}

/**
 * Persiste el estado completo de validación en SharePoint.
 * Sobreescribe el archivo cada vez (estrategia "last write wins" — el
 * número de revisores es muy bajo y la coordinación es humana).
 *
 * @param {object} state Objeto JSON serializable con el esquema completo.
 */
export async function saveValidationJson(state) {
  const client = getGraphClient()
  const siteId = await getSiteId()
  const encoded = encodePathSegments(VALIDATION_PATH)
  const endpoint = `/sites/${siteId}/drive/root:/${encoded}:/content`

  const body = JSON.stringify(state, null, 2)
  return client
    .api(endpoint)
    .header('Content-Type', 'application/json')
    .put(body)
}
